import clsx from 'clsx'
import {getGoogleAuthUrl} from 'common/HelperFunctions'
import {useState} from 'react'

type Props = {
  disabled?: boolean
  isSpecialDomain?: boolean
}

export function ForgotSetPasswordGoogleButton({disabled = false, isSpecialDomain = true}: Props) {
  const [isGoogleHover, setIsGoogleHover] = useState(false)

  if (!import.meta.env.VITE_GOOGLE_CLIENT_ID) {
    return null
  }

  return (
    <>
      <div className='separator separator-content my-6'>
        <span
          className={clsx('fw-semibold fs-7', isSpecialDomain ? 'text-white-50' : 'text-gray-500')}
        >
          Or
        </span>
      </div>
      <div className='d-flex justify-content-center' style={{position: 'relative', width: '100%'}}>
        <button
          type='button'
          onMouseEnter={() => setIsGoogleHover(true)}
          onMouseLeave={() => setIsGoogleHover(false)}
          disabled={disabled}
          onClick={() => {
            const authUrl = getGoogleAuthUrl()
            if (!authUrl) return
            const returnTo = `${window.location.origin}/auth/google-password-reset-callback`
            window.location.href = `${authUrl}/auth/google-login?returnTo=${encodeURIComponent(returnTo)}`
          }}
          className='btn d-flex align-items-center justify-content-center gap-3 w-100'
          style={{
            background: isSpecialDomain
              ? isGoogleHover
                ? 'rgba(255, 255, 255, 0.14)'
                : 'rgba(255, 255, 255, 0.08)'
              : isGoogleHover
                ? '#f8f9fa'
                : '#fff',
            border: isSpecialDomain
              ? isGoogleHover
                ? '1px solid rgba(255, 255, 255, 0.28)'
                : '1px solid rgba(255, 255, 255, 0.15)'
              : isGoogleHover
                ? '1px solid #c9ccd1'
                : '1px solid #dadce0',
            borderRadius: 10,
            padding: '10px 24px',
            color: isSpecialDomain ? '#fff' : '#3c4043',
            fontSize: 14,
            fontWeight: 500,
            opacity: disabled ? 0.55 : 1,
            transform: isGoogleHover ? 'translateY(-1px)' : 'translateY(0)',
            transition: 'all 180ms ease',
          }}
        >
          <svg width='20' height='20' viewBox='0 0 48 48' aria-hidden='true'>
            <path
              fill='#EA4335'
              d='M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z'
            />
            <path
              fill='#4285F4'
              d='M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z'
            />
            <path
              fill='#FBBC05'
              d='M10.53 28.59a14.5 14.5 0 0 1 0-9.18l-7.98-6.19a24.09 24.09 0 0 0 0 21.56l7.98-6.19z'
            />
            <path
              fill='#34A853'
              d='M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z'
            />
          </svg>
          Continue with Google
        </button>
      </div>
    </>
  )
}
